module.exports = {
    "crude": {
        "search": "Căuta",
        "actions": "Acțiuni",
        "nextPage": "Pagina următoare",
        "lastPage": "Pagina anterioară",
        "back": "Înapoi",
        "empty": "gol",
        "edit": "Editați | ×",
        "create": "crea",
        "data": "record",
        "view": "spectacol",
        "delete": "Șterge",
        "save": "Salvați",
        "cancel": "Anulare",
        "noContent": "Nu există intrări disponibile. ",
        "resetFilter": "Resetați filtrele și vedeți mai mult conținut!",
        "createOwnTextField": "Creați-vă propriul câmp de text",
        "textFieldName": "eticheta câmpului de text",
        "textFieldValue": "Cuprins",
        "insertTextFieldLabel": "Vă rugăm să introduceți numele câmpului de text!",
        "deleteTextField": "Ștergeți câmpul de text",
        "success": "Salvarea a avut succes",
        "invalidDataFields": "Următoarele câmpuri de date sunt nevalide:  ",
        "entries": "intrări",
        "entry": "intrare",
        "tabDetail": "Detalii",
        "entity": "entitate",
        "of": "din",
        "uploadNewFile": "Incarca fisier",
        "upload": "încărcați",
        "confirm": "Bine",
        "deleteFileQuestion": "Chiar doriți să ștergeți acest fișier? ",
        "deleteFileQuestionTitle": "Pericol!",
        "deleteEntityQuestion": "Chiar doriți să ștergeți această entitate? ",
        "deleteEntityQuestionTitle": "Pericol!",
        "errorLargeFileUpload": "Fișierul selectat este prea mare!",
        "useCroppedImage": "Folosiți crop",
        "useOriginalImage": "Utilizați imaginea originală",
        "available": "disponibil",
        "searchColumn": "găsiți coloana",
        "manageColumns": "Gestionați coloanele",
        "hideColumn": "ascunde coloana",
        "pinToRight": "Fixați coloana la dreapta",
        "pinToLeft": "Fixați coloana din stânga",
        "sortAsc": "Sortare ascendentă",
        "sortDesc": "Sortează descrescător",
        "hideAll": "ascunde totul",
        "showAll": "Arata tot",
        "preview": "previzualizare",
        "title": "titlu",
        "description": "Descriere",
        "tooltip": "tooltip",
        "sort": "filtrează după",
        "settings": "Setări",
        "incomingReference": "referinţă",
        "language": "Limba",
        "deleteTabQuestionTitle": "Pericol!",
        "deleteTabQuestion": "Chiar doriți să ștergeți această filă? ",
        "deleteElementQuestionTitle": "Pericol!",
        "deleteElementQuestion": "Chiar doriți să ștergeți acest articol? ",
        "configurationEditorDescriptionStringLayout": "În această coloană, pot fi selectate trei variante pentru introducerea textului:",
        "configurationEditorDescriptionEnumLayout": "Pentru selectarea elementelor din această coloană pot fi selectate două variante:",
        "configurationEditorDescriptionBooleanLayout": "Pentru selectarea elementelor din această coloană pot fi selectate două variante:",
        "configurationEditorDescriptionForeignEntityLayout": "Pentru selectarea elementelor din această coloană pot fi selectate două variante:",
        "stringLayoutsingleline": "o singura linie",
        "stringLayoutmultiline": "multilinie",
        "stringLayouteditor": "Editor de text îmbogățit",
        "enumLayoutradio": "buton de radio",
        "enumLayoutdropdown": "scapă jos",
        "booleanLayoutcheckbox": "Caseta de bifat",
        "booleanLayoutswitch": "întrerupătoare",
        "foreignEntityLayoutpopUp": "pop-up",
        "foreignEntityLayoutautocomplete": "scapă jos",
        "foreignEntityLayoutlist": "listă",
        "formatTooltipbold": "Gras",
        "formatTooltipitalic": "cursiv",
        "formatTooltipunderline": "subliniat",
        "formatTooltipstrike": "Barat",
        "formatTooltipclean": "formatare clară",
        "formatTooltipcodeBlock": "cod",
        "formatTooltipblockquote": "Citat",
        "formatTooltipcolor": "culoarea fontului",
        "formatTooltipbackground": "culoare de fundal",
        "formatTooltipfont": "font",
        "formatTooltipalign": "aliniere",
        "formatTooltipheader": "marimea fontului",
        "formatTooltipsuper": "Superscript",
        "formatTooltipsub": "indicele",
        "formatTooltipordered": "Lista ordonata",
        "formatTooltipbullet": "Enumerare",
        "true": "da",
        "false": "Nu",
        "selectEntity": "selectați entitatea",
        "filter": "filtru",
        "useFilter": "Aplicați filtre",
        "defaultFilter": "resetează filtrul",
        "expand": "extinde",
        "hide": "ascunde",
        "minimumSelectionError": "Trebuie selectate cel puțin {{min}} intrări.",
        "maximumSelectionError": "Pot fi selectate maximum {{max}} intrări."
    }
}
;